import { useEventBus } from '@vueuse/core'
import { useBankerStore } from '@ms/stores/betslip/useBanker.js'
import { getLocalSelections, saveLocalSelections } from '@ms/components/betslip/core/save.js'
import { removeSelectionsBets } from '@ms/utils/betslipValueCache'
import { useBetslipStore } from '@ms/stores/betslip'
import { useSystemBetStore } from '@ms/stores/betslip/useSystemBet.js'
import { isBetBuilderSelection } from '@ms/stores/betslip/func'

export default {
  updateFromLocalSelections() {
    this.selectionList = getLocalSelections()
  },
  addSelection(selection = {}) {
    const { id } = selection
    if (isBetBuilderSelection(selection)) {
      const targetSelection = this.selectionList.find((x) => x.id === id)
      if (targetSelection) {
        targetSelection.betBuilderSelections.push(...selection.betBuilderSelections)
      } else {
        this.selectionList.push(selection)
      }
      useEventBus('add-betslip-selection').emit(selection)
    } else {
      const isSelected = this.selectionList.findIndex((x) => x.id === id)
      if (isSelected === -1) {
        this.selectionList.push(selection)
        useEventBus('add-betslip-selection').emit(selection)
      }
    }
    // 更新本地信息
    saveLocalSelections(this.selectionList)
  },
  removeSelection(selection, isCombos = false) {
    const { id } = selection
    const index = this.selectionList.findIndex((x) => x.id === id)
    if (isBetBuilderSelection(selection)) {
      const { betBuilderSelections } = selection
      const size = betBuilderSelections.length
      if (!size) return
      if (size > 1) {
        if (isCombos) {
          betBuilderSelections.forEach((subSelection) => {
            this.removeBetBuilderSelection(id, subSelection.id)
          })
        } else {
          this.selectionList.splice(index, 1)
        }
      } else {
        this.removeBetBuilderSelection(id, betBuilderSelections[0].id)
      }
    } else {
      this.selectionList.splice(index, 1)
    }

    useEventBus('remove-betslip-selection').emit(selection)
    // 更新本地信息
    saveLocalSelections(this.selectionList)
    removeSelectionsBets(id, 'selections')

    if (!this.selectionList.length) {
      useBetslipStore().updateSelectionChanged(false)
    }
  },
  // remove all
  updateRemoveAllSelections() {
    this.selectionList.splice(0)
    useEventBus('remove-betslip-selection').emit()
    // 更新本地信息
    saveLocalSelections(this.selectionList)
    removeSelectionsBets()
  },

  removeBetBuilderSelection(id, subSelectionId = '') {
    const selection = this.selectionList.find((x) => x.id === id)
    if (selection) {
      const { betBuilderSelections } = selection
      const index = betBuilderSelections.findIndex((x) => x.id === subSelectionId)
      if (index !== -1) {
        const subSelection = betBuilderSelections[index]
        betBuilderSelections.splice(index, 1)

        useEventBus('remove-betslip-selection').emit({ ...selection, betBuilderSelections: [subSelection] })
      }
      if (betBuilderSelections.length === 0) {
        const index = this.selectionList.findIndex((x) => x.id === id)
        this.selectionList.splice(index, 1)
      } else {
        this.updateBetBuilderOdds()
      }

      // 更新本地信息
      saveLocalSelections(this.selectionList)
    }
  },

  resetBetslip() {
    this.selectionList.splice(0)
    // 更新本地信息
    saveLocalSelections(this.selectionList)
    useBetslipStore().resetCacheStake()
    useSystemBetStore().$reset()
    useBankerStore().$reset()
  },

  // 更新快速投注的stake
  updateFastStake(stake) {
    this.fastStake = +stake
  }
}
